<style lang="scss">
  .upload-app-launcher-wrapper {
    width: 48px;
    height: 48px;
    z-index: 2000;
  }

  .upload-app-launcher {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #0074e4;
    cursor: pointer;
    box-shadow:
      0 1px 6px 0 rgba(0, 0, 0, 0.06),
      0 2px 32px 0 rgba(0, 0, 0, 0.16);
    border: none;

    &:hover {
      transform: scale(1.1);
    }

    &:focus {
      outline: none;
    }
  }

  .upload-launcher-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 48px;
    height: 48px;
  }

  @media print {
    .upload-app-launcher {
      display: none;
    }
  }

  .upload-app-launcher-badge {
    position: relative;
    top: 6px;
    left: 44px;
    z-index: 2000;
  }
</style>

<script>
  import Badge from "@sourcewhale/shared/svelte-design-system/components/atoms/Badge.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { onMount } from "svelte";
  import { PROCESSED_STATUSES } from "./assets";
  import { uploadsModalStore, uploadsNotificationsStore } from "./stores";

  onMount(() => {
    uploadsNotificationsStore.once();
  });

  const toggleModal = (e) => {
    e.stopPropagation();
    uploadsModalStore.update((n) => !n);
  };

  let badgeCount = $derived(
    $uploadsNotificationsStore?.notifications?.filter(
      (n) => !n?.viewed && PROCESSED_STATUSES.includes(n.status)
    )?.length || null
  );
</script>

<div class="upload-app-launcher-wrapper">
  <div class="upload-app-launcher-badge">
    {#if badgeCount}
      <Badge
        value={badgeCount}
        type="number"
        contrast="yellow"
        position="right"
      />
    {/if}
  </div>
  <button
    class="upload-app-launcher"
    onclick={toggleModal}
    type="button"
    uploads-widget-launch-button
  >
    <div class="upload-launcher-icon">
      {#if $uploadsModalStore}
        <Icon class="fa-solid fa-chevron-down color-textWhite" size="large" />
      {:else}
        <Icon class="fa-solid fa-upload color-textWhite" size="large" />
      {/if}
    </div>
  </button>
</div>
